module.exports = __webpack_public_path__ + "static/media/IMG_5603.2bf4a5ba.jpg";